import { useState } from 'react'
import dayjs from 'dayjs'
import API from '@services'
import { Button } from '@components/common'
import { DemoItem } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { IClosure } from '@store/features/closure/closure.types'
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'

import { ClosureItemWrapper, ButtonsWrapper } from '../../styled'

interface Props {
  closure: IClosure
  next: (closureId?: string) => void
  reload: () => void
}

const ClosuresItem = ({ next, closure, reload }: Props) => {
  const [loading, setLoading] = useState(false)

  const deleteItem = async () => {
    setLoading(true)
    await API.closure.delete(closure.id)
    reload()
    setLoading(false)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ClosureItemWrapper>
        <DemoItem label='Start Date'>
          <DateTimePicker
            sx={{
              input: {
                border: 'none !important'
              }
            }}
            format='MM/DD/YYYY'
            defaultValue={dayjs(closure.startDate)}
            disabled
          />
        </DemoItem>
        <DemoItem label='End Date'>
          <DatePicker
            sx={{
              input: {
                border: 'none !important'
              }
            }}
            format='MM/DD/YYYY'
            defaultValue={dayjs(closure.endDate)}
            disabled
          />
        </DemoItem>
      </ClosureItemWrapper>
      <ButtonsWrapper>
        <Button variant='contained' color='primary' type='button' onClick={() => next(closure.id)}>
          Edit
        </Button>
        <Button isLoading={loading} variant='outlined' color='primary' type='button' onClick={deleteItem}>
          Delete
        </Button>
      </ButtonsWrapper>
      <hr style={{ marginBottom: '30px' }} />
    </LocalizationProvider>
  )
}

export default ClosuresItem
